@let i18n = translate();
<app-spinner-loader [message]="i18n.FetchingYourInfo"></app-spinner-loader>
